import React from 'react';
import { Button, Flex, Heading, StatusIndicator, Text } from '@chatsdet/ui';
import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../config';
import { useAuth } from '../../contexts/AuthContext';

export function Debug() {
  const { user, signOut, refetchUser } = useAuth();
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const jira = useQuery({
    queryKey: ['jira-debug'],
    queryFn: async () => {
      const res = await fetch(API_URL + '/integrations/jira/validate', { credentials: 'include' });
      const body = await res.json();
      return body as { ok: boolean; details?: unknown };
    },
  });

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await fetch(API_URL + '/auth/refresh', { method: 'POST', credentials: 'include' });
      await refetchUser();
    } finally {
      setIsRefreshing(false);
    }
  };

  const reauthJira = () => {
    window.location.href = API_URL + '/integrations/jira/oauth/start';
  };

  return (
    <div>
      <Heading level={2}>Debug</Heading>
      <Flex direction="column" gap="xs">
        <div>
          <Heading level={4}>Session</Heading>
          <Text>
            {user ? `Signed in as ${user.email ?? user.id}` : 'Not signed in'}
          </Text>
          <div>
            <Button
              variant="primary"
              onPress={handleRefresh}
              isDisabled={isRefreshing}
            >
              {isRefreshing ? 'Refreshing…' : 'Refresh session'}
            </Button>
            <Button
              variant="secondary"
              onPress={signOut}
            >
              Sign out
            </Button>
          </div>
        </div>

        <div>
          <Heading level={4}>Jira</Heading>
          <StatusIndicator variant={jira.data?.ok ? 'positive' : 'negative'}>
            {jira.data?.ok ? 'Connected' : 'Not connected'}
          </StatusIndicator>
          {!jira.data?.ok && (
            <div>
              <Button variant="primary" onPress={reauthJira}>
                Connect Jira
              </Button>
            </div>
          )}
        </div>
      </Flex>
    </div>
  );
}
